const defaultSetting = {
  isMute: false
}

export default {
  namespaced: true,
  state: defaultSetting,
  mutations: {
    toogleMute (state) {
      state.isMute = !state.isMute
    }
  }
}
